import { render, staticRenderFns } from "./SetupCamera.vue?vue&type=template&id=8d017860"
import script from "./SetupCamera.vue?vue&type=script&lang=js"
export * from "./SetupCamera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports